import { Controller } from "@hotwired/stimulus"

const LG_BREAKPOINT = 1024

export default class extends Controller {
  static targets = ["left", "right", "handle"]
  static values = {
    storageKey: { type: String, default: "split-panel-ratio" },
    minLeft: { type: Number, default: 25 },
    minRight: { type: Number, default: 25 },
    defaultRatio: { type: Number, default: 42 }
  }

  connect() {
    this.dragging = false
    this.boundOnMouseMove = this.onMouseMove.bind(this)
    this.boundOnMouseUp = this.onMouseUp.bind(this)
    this.boundHandleResize = this.handleResize.bind(this)
    window.addEventListener("resize", this.boundHandleResize)

    this.handleResize()
  }

  disconnect() {
    document.removeEventListener("mousemove", this.boundOnMouseMove)
    document.removeEventListener("mouseup", this.boundOnMouseUp)
    window.removeEventListener("resize", this.boundHandleResize)
  }

  onMouseDown(event) {
    event.preventDefault()
    this.dragging = true
    this.element.classList.add("select-none")
    document.addEventListener("mousemove", this.boundOnMouseMove)
    document.addEventListener("mouseup", this.boundOnMouseUp)
  }

  onMouseMove(event) {
    if (!this.dragging) return

    const rect = this.element.getBoundingClientRect()
    const ratio = ((event.clientX - rect.left) / rect.width) * 100

    this.applyRatio(ratio)
  }

  onMouseUp() {
    if (!this.dragging) return
    this.dragging = false
    this.element.classList.remove("select-none")
    document.removeEventListener("mousemove", this.boundOnMouseMove)
    document.removeEventListener("mouseup", this.boundOnMouseUp)

    const currentRatio = parseFloat(this.leftTarget.style.width)
    localStorage.setItem(this.storageKeyValue, currentRatio.toString())

    // Notify PDF viewer to re-render after resize
    window.dispatchEvent(new Event("resize"))
  }

  handleResize() {
    if (window.innerWidth < LG_BREAKPOINT) {
      this.leftTarget.style.removeProperty("width")
      this.rightTarget.style.removeProperty("width")
      return
    }

    const saved = localStorage.getItem(this.storageKeyValue)
    const ratio = saved ? (parseFloat(saved) || this.defaultRatioValue) : this.defaultRatioValue
    this.applyRatio(ratio)
  }

  applyRatio(ratio) {
    const constrainedRatio = Math.max(this.minLeftValue, Math.min(100 - this.minRightValue, ratio))
    this.leftTarget.style.width = `${constrainedRatio}%`
    this.rightTarget.style.width = `${100 - constrainedRatio}%`
  }
}
